import { Link } from 'react-router-dom';
import type { Topic } from '@/types/content';
import { topics } from '@/mocks/topics';
import SectionHeading from '@/components/feature/SectionHeading';
import TopicCard from '@/components/feature/TopicCard';
import Reveal from '@/components/feature/Reveal';

const allTopics = topics as Topic[];

export default function RecommendSection() {
  const recommended = allTopics.slice(2, 8);

  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20 bg-background-50">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8 md:mb-10">
        <SectionHeading
          eyebrow="For you"
          title="值得一读的内容推荐"
          description="被群众反复点开、收藏和转发的记录，大多藏在这些条目里。"
        />
        <Link
          to="/frontline"
          className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-700 hover:text-primary-800 transition-colors whitespace-nowrap"
        >
          更多内容
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {recommended.map((topic, index) => (
          <Reveal key={topic.id} delay={(index % 3) * 90}>
            <TopicCard topic={topic} />
          </Reveal>
        ))}
      </div>
    </section>
  );
}